module.exports = __webpack_public_path__ + "img/face-grin-stars.13747081.svg";